<template>
  <div class="home-con-ad">
    <div class="home">
      <div class="homeHeaderCon">
        <div
          class="homeHeaderP"
          :style="{ 'background-color': homeheaderbgcolor }"
        >
          <div class="homeHeader">
            <div class="logo" @click="gofirstPage">
              <img v-if="logosrc" :src="logosrc" alt="logo" />
            </div>
            <div
              v-if="userInfo"
              class="otherCon"
              :style="{ 'justify-content': navpos }"
            >
              <div class="nav">
                <ul class="nav-content">
                  <li
                    v-for="(item, index) in modelsInfo_real"
                    v-if="item.status == 1"
                    :key="index"
                    @click="changeModel(item, index)"
                  >
                    <router-link
                      :class="{
                        activeSty: index == activeChanelIndex,
                        noactiveSty: index != activeChanelIndex,
                        disable: item.page_name == '视频素材'
                      }"
                      :to="item.path"
                      v-text="item.page_name"
                    ></router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div style=" align-items: center;display: flex;">
              <div class="loginBtn" v-if="!userInfo && isOuthtoken">
                <div class="btnContent">
                  <a class="sogin" :href="redictUrl">统一认证登录</a>
                </div>
              </div>
              <div class="loginBtn" v-if="!userInfo">
                <div class="btnContent">
                  <!--<div style="margin-right:5px" class="iconfont icon-Shapecopy"></div>-->
                  <!--<div class="loginbtn-item">-->
                  <!--<router-link class="login-left" to="/loginAd">登录11</router-link>-->
                  <!--</div>-->
                  <!--<div>/</div>-->
                  <!--<div class="loginbtn-item">-->
                  <router-link class="login-right" to="/register"
                    >注册用户</router-link
                  >
                  <!--</div>-->
                </div>
              </div>
              <div class="userPerson userInfo" v-else>
                <el-dropdown trigger="click" placement="top" v-if="userInfo">
                  <div class="personLogo">
                    <span
                      >{{ userInfo.user_name }}
                      <i class="el-icon-arrow-down"></i>
                    </span>
                    <a class="userHead">
                      <img :src="userInfo.img_path" alt="" />
                    </a>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <span @click="toPersonal">个人中心</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <span @click="signOut">退出登录</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="routerview">
        <router-view></router-view>
      </div>
    </div>
    <div v-if="isshowSidebar" class="righttoolbal">
      <div class="itemcon">
        <div class="tel" @mouseover="mouseoverT" @mouseout="mouseoutT">
          <div>
            <div class="iconfont icon-erji" style="text-align:center"></div>
            <div style="text-align:center">购</div>
            <div style="text-align:center">买</div>
            <div style="text-align:center">咨</div>
            <div style="text-align:center">询</div>
          </div>
          <!--  -->
          <div v-if="TelInfoShow" class="telinfo">
            <!-- <div>Tel:</div> -->
            <div>联系电话:</div>
            <div>&nbsp;&nbsp;{{ sidebarTel }}</div>
            <div>工作时间:</div>
            <div>&nbsp;&nbsp;{{ sidebarTime }}</div>
            <!-- <div>����:14:30-17:30</div> -->
          </div>
        </div>
        <!-- <div class="collection" @click="toPersonal(1)" @mouseover="mouseoverC" @mouseout="mouseoutC">
          <div :class="[{collec:collectionShow},'iconfont','icon-shoucang']" style="text-align:center"></div>
          <div class="collectioninfo" v-if="collectionShow">收藏夹</div>
        </div>
        <div class="download" @click="toPersonal(2)" @mouseover="mouseoverD" @mouseout="mouseoutD">
          <div :class="[{jilu:downloadShow},'iconfont','icon-lishijilu']" style="text-align:center"></div>
          <div class="downloadinfo" v-if="downloadShow">下载记录</div>
        </div> -->

        <div class="txqq" style="text-align:center">
          <a
            target="_blank"
            :href="
              'http://wpa.qq.com/msgrd?v=3&uin=' +
                sidebarQQ +
                '&site=qq&menu=yes'
            "
          >
            <div
              class="txqqcon"
              @mouseover="mouseoverQQ"
              @mouseout="mouseoutQQ"
            >
              <div
                :class="[{ qq: qqcom }, 'iconfont', 'icon-qq']"
                style="color:white"
              ></div>
              <div class="qqcom" v-if="qqcom">QQ客服</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import modelTwoNew from "./modelTwoNew.vue";
import homeHeader from "../components/homeHeader.vue"; //头部
import modelAd from "./modelAd.vue";
import allClassification from "./allClassification.vue";
import modelOne from "./modelOne.vue";
import modelTwo from "./modelTwo.vue";
import modelThree from "./modelThree.vue";
import modelAdBeforeLogin from "./modelAdBeforeLogin.vue";
import recommend from "./recommend.vue";
import valueaddservice from "./valueaddservice.vue";
import aboutUs from "./aboutUs.vue";
import topic from "./topic.vue";
import { mapActions, mapGetters } from "vuex";
import imgCardVue from "../components/imgCard.vue";
import {
  getModulStyle,
  getWebModels,
  getModuleInfo,
  getdoctitle,
  signOut,
  getwebid
} from "@/services/api.js";
import pbmethod from "../publicmethod.js";
export default {
  data() {
    return {
      showType: false, //导航菜单
      webID: 1,
      isOuthtoken: false,
      redictUrl: "http://gaonengsuo.my/gnsAuth",
      sidebarQQ: "",
      sidebarTel: "",
      sidebarTime: "",
      isshowSidebar: false,
      userInfo: false,
      modelShow: 1,
      opacity: "0.68",
      TelInfoShow: false,
      collectionShow: false,
      downloadShow: false,
      qqcom: false,
      navpos: "center",
      select: "0",
      searchText: "",
      homeColor: {
        id: "",
        list: [{ body: "rgba(255,255,255)" }]
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      realopacity: this.opacity,
      homeheaderbgcolor: "rgba(255,255,255)",
      keyI: 0,
      modelsInfo_real: []
    };
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        if (val.name == "LoginAd") {
          this.userInfo = false;
          localStorage.removeItem("user");
          localStorage.removeItem("token");
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("token");
          this.setLoginSign(false);
        }
      },
      // 深度观察监听
      deep: true
    },
    login_success: {
      handler(val) {
        this.userInfo = sessionStorage.getItem("user")
          ? JSON.parse(sessionStorage.getItem("user"))
          : false;
      }
    },
    "curModelInfo.tpl_id": {
      handler() {
        window.scrollTo(0, 0);
      },
      deep: true
    },
    keyI(val) {
      if (val == 13) {
        this.toSearch();
      }
    },
    modelsInfo(val, oldval) {
      val.forEach(item => {
        item["path"] = this.getPathByTplId(item);
        this.modelsInfo_real.push(item);
      });
      if (!sessionStorage.getItem("first")) {
        sessionStorage.setItem("first", 0);
        sessionStorage.setItem("fitstPath", this.modelsInfo_real[0].path);
        // this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
        this.setCurModelInfo(val[0]);
      } else {
        let sindex = sessionStorage.getItem("first");
        this.setActiveChanelIndex(sindex);
        this.setCurModelInfo(val[sindex]);
      }
    },
    realopacity() {
      if (this.realopacity == "1") {
        this.homeheaderbgcolor = pbmethod.colorRgb(this.homeColor.list[0].body);
      } else {
        this.homeheaderbgcolor = pbmethod.colorRgb(
          this.homeColor.list[0].body,
          "0.5"
        );
      }
    }
  },
  props: {
    issearch: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  mounted() {
    // this.setExample("改变了");
  },
  created() {
    getwebid({ domainName: window.location.host }).then(data => {
      if (data) {
        this.webID = data.data;
        this.keyevent();
        this.getModuleInfo();
        this.getdoctitle();
      }
    });
    if (this.$route.query.text) {
      this.select = this.$route.query.type;
      this.searchText = decodeURI(this.$route.query.text);
    }
  },
  computed: {
    logosrc() {
      if (this.logo.list.length > 0) {
        this.setLogoSrc(this.logo.list[0].photo1);
        return this.logo.list[0].photo1;
      } else {
        this.setLogoSrc("");
        return "";
      }
    },

    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",

      "activeChanelIndex",
      "login_success"
    ])
  },
  methods: {
    ...mapActions([
      "setCurModelInfo",
      "setWebModels",
      "setActiveChanelIndex",
      "setLogoSrc",
      "setLoginSign"
    ]),
    getdoctitle() {
      getdoctitle({ uid: this.webID }).then(x => {
        let oauth_status = x.data.oauth_status;
        if (oauth_status == 1) {
          //接入
          this.isOuthtoken = true;
          let oauth_token_url = x.data.oauth_token_url;
          // this.redictUrl = oauth_token_url.domain;
          this.redictUrl = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=83843&theme=full/simple/embed"`;
          //
        } else {
          //未接入
        }
      });
    },
    getPathByTplId(item) {
      switch (item.tpl_id) {
        case 1:
          return "modeltwo";
        case 2:
          return "modelone";
        case 3:
          return "modelthree";
        case 4:
          return "special";
        case 10:
          return "loginbf";
        case 7:
          return "service";
        case 8:
          return "recommend";
        case 9:
          return "aboutus";
        case 6:
          return "modelad";
        case 11:
          return "allclassnew";
        case 13:
          return "modeltwonew";
        case 14:
          return "taskCollection";
      }
    },
    keyevent() {
      var that = this;
      document.onkeydown = function(e) {
        //按下键盘
        that.keyI = e.keyCode;
      };
    },
    gofirstPage() {
      this.setCurModelInfo(this.modelsInfo[0]);
      this.setActiveChanelIndex(0);
      sessionStorage.setItem("first", 0);
      this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
    },
    signOut(type) {
      this.userInfo = false;
      signOut().then(res => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        this.setLoginSign(false);
        window.location.href = "https://login.ihep.ac.cn/logout";
      });
    },
    changeModel(module, index) {
      // ;
      this.setCurModelInfo(module);
      // if (module.page_name == "视频素材") {
      //   this.$message({
      //     type: "warning",
      //     showClose: true,
      //     message: "建设中",
      //     duration: 1000
      //   });
      //   return;
      // }
      this.setActiveChanelIndex(index);
      sessionStorage.setItem("first", index);
      // if (module.tpl_id === 4) {
      //   this.$router.push({ path: "/special" });
      // } else {
      //   this.$router.push({ path: "/" });
      // }
    },
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          type: this.select,
          text: encodeURI(this.searchText)
        }
      });
    },
    toPersonal() {
      // http://www.zsphoto.cn:8000/#/login
      // http://localhost:8180/#/login
      // http://pre.saasdam.vcg.com/#/login
      //http://saasdam.vcg.com/#/login
      // http://damtest.ihep.ac.cn:8000
      // "http://damtest.ihep.ac.cn:8000/#/login?token=" +token +"&activename=name1",

      var token = sessionStorage.getItem("token");
      window.open(
        "http://saasdam.vcg.com/#/login?token=" + token + "&activename=name1",
        "_blank"
      ).location;
    },
    getModuleInfo() {
      this.userInfo = sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = homeColor.id;
          //
          getModuleInfo(
            { module_id: 5, use_sort_num: 1, sort: "asc" },
            null
          ).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              this.homeheaderbgcolor = pbmethod.colorRgb(
                this.homeColor.list[0].body
              );
            }
          });

          data = {
            module_id: 23,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data).then(res => {
            if (res.status_code == 1) {
              switch (res.data.list[0].nav) {
                case 1:
                  this.navpos = "flex-start";
                  break;
                case 2:
                  this.navpos = "center";
                  break;
                case 3:
                  this.navpos = "flex-end";
                  break;
              }
              this.isshowSidebar = eval(res.data.list[0].body4);
              this.sidebarQQ = res.data.list[0].body5;
              this.sidebarTel = res.data.list[0].body6;
              this.sidebarTime = res.data.list[0].body7;
            }
          });
        }
      }, 0);
    },
    // toPersonal(id) {
    //   var token = sessionStorage.getItem("token");
    //   if (token) {
    //     var nm = id == 1 ? "name1" : "name2";
    //     // http://www.zsphoto.cn:8000/#/login
    //     // http://localhost:8180/#/login
    //     // http://pre.saasdam.vcg.com/#/login
    //     //http://saasdam.vcg.com/#/login
    //     window.open(
    //       "http://saasdam.vcg.com/#/login?token=" + token + "&activename=" + nm,
    //       "_blank"
    //     ).location;
    //   } else {
    //     this.$router.push({
    //       path: "/login"
    //     });
    //   }
    // },
    mouseoverT() {
      this.TelInfoShow = true;
    },
    mouseoutT() {
      this.TelInfoShow = false;
    },
    mouseoverC() {
      this.collectionShow = true;
    },
    mouseoutC() {
      this.collectionShow = false;
    },
    mouseoverD() {
      this.downloadShow = true;
    },
    mouseoutD() {
      this.downloadShow = false;
    },
    mouseoverQQ() {
      this.qqcom = true;
    },
    mouseoutQQ() {
      this.qqcom = false;
    },
    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    }
  },
  components: {
    recommend,
    valueaddservice,
    aboutUs,
    modelOne,
    modelTwo,
    modelThree,
    topic,
    modelAdBeforeLogin,
    modelAd,
    homeHeader,
    allClassification,
    modelTwoNew
  }
};
</script>
<style lang="less" scoped>
.home-con-ad {
  display: flex;
  display: -webkit-flex;
  .activeSty {
    color: #333;
    // font-weight: bold;
    font-size: 16px;
  }
  .noactiveSty {
    color: #333;
    font-size: 13px;
  }
  .disable {
    color: rgba(121, 7, 7, 0.3);
  }
  .nav-content {
    li {
      margin-left: 40px;
    }
  }
  .homeHeaderCon {
    width: 100%;
    height: 70px;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: auto;
    margin-left: auto;
  }
  .homeHeaderP {
    width: 100%;
    height: 70px;
    background: #fff;
    .homeHeader {
      margin: 0 auto;
      width: 1200px;
      height: 70px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          max-width: 200px;
          max-height: 50px;
        }
      }
      .otherCon {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        width: calc(100% - 400px);
        .nav {
          height: 100%;
        }
      }
      .nav {
        margin-right: 20px;
        min-width: 200px;
        .nav-content {
          display: flex;
          height: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          line-height: 20px;
          height: 100%;
          // padding-top: 24px;
          justify-content: flex-start;

          li {
            color: rgba(44, 62, 76, 1);
            display: flex;
            display: -webkit-flex;
            align-items: center;
            a {
              // font-size: 14px;
            }
          }
        }
      }
      .search {
        width: 345px;
        height: 40px;
        margin-right: 40px;
        display: flex;
        .el-select {
          padding-right: 0;
          width: 150px;
        }
        .el-button {
          background-color: #f05941;
          color: #fff;
          padding: 0px;
          height: 40px;
          width: 40px;
          font-size: 20px;
        }
        .el-input-group {
          width: 250px;
        }
      }
      .loginBtn {
        width: 98px;
        height: 40px;

        border-radius: 3px;
        .btnContent {
          line-height: 20px;
          height: 20px;
          width: 85px;
          margin-top: 10px;
          margin-left: 8px;
          display: flex;
          justify-content: space-between;

          a {
            font-size: 16px;
            display: block;
            width: 100%;
            text-align: right;
            color: #595959;
          }
          a:hover {
            color: red;
          }
        }
      }
      .userInfo {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .personLogo {
          display: flex;
          display: -webkit-flex;
        }
        span {
          font-size: 16px;
          // line-height: 45px;
          cursor: pointer;
          vertical-align: middle;
          display: flex;
          display: -webkit-flex;
          align-items: center;
        }
        .userHead {
          margin-left: 10px;
          display: inline-block;
          width: 45px;
          height: 45px;
          vertical-align: middle;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }

      .homeHeaderTwo {
        width: 100%;
        height: 70px;
        position: fixed;
        display: flex;
        z-index: 1000;
        .logo {
          height: 100%;
          width: 120px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .righttoolbal {
    width: 30px;
    background-color: #212121;
    z-index: 9999;
    color: white;
    .itemcon {
      position: fixed;
      top: 300px;
      width: 30px;
      .tel {
        background-color: red;
        position: relative;
        height: 100px;
        .telinfo {
          background-color: white;
          position: absolute;
          left: -150px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          color: #757575;
          padding-left: 20px;
          padding-top: 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
      .collection {
        margin-top: 20px;
        position: relative;
        .collec {
          background-color: red;
        }
        .collectioninfo {
          background-color: red;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
          text-align: center;
        }
      }
      .download {
        margin-top: 20px;
        position: relative;
        .jilu {
          background-color: red;
        }
        .downloadinfo {
          background-color: red;
          text-align: center;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
        }
      }
      .txqq {
        margin-top: 20px;
        color: white;
        .txqqcon {
          position: relative;
          .qq {
            background-color: red;
          }
          .qqcom {
            background-color: red;
            color: white;
            position: absolute;
            left: -100px;
            top: 0px;
            bottom: 0px;
            right: 30px;
            line-height: 24px;
            padding-left: 10px;
          }
        }
      }
    }
  }
  .home {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homeAd.vue